import { Injectable } from '@angular/core';
import { HttpService } from './../services/http.service';
import { DIMBO_CONSTANT } from './../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private httpService : HttpService) { }

  // Method to call a API to get count of service.
  public getServiceCount() {
     return this.httpService.serviceCount(DIMBO_CONSTANT.SERVICE_COUNT);
  }

  // Method to call a API to get count of contract.
  public getContractCount() {
    return this.httpService.contractCount(DIMBO_CONSTANT.CONTRACT_COUNT);
 }
}